import { Alignment, Displaying, Spacing } from "@bonusx-global/bx-design-system";
import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const TwoButtonsWarningModalActionsWrapper = styled(Box)({
  display: Displaying.flex,
  alignItems: Alignment.center,
  justifyContent: Alignment.center,
  gap: Spacing[750],
});
